var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoJetforce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 104.6",
    style: {
      enableBackground: "new 0 0 104 104.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#064B93;}\n\t.st1{fill:#98C226;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#FEFFFF;stroke-width:0.6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-Approve",
    transform: "translate(0.194 0.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    className: "st0",
    d: "M-0.2,61.1h104l0,0v33.2c0,5.5-4.5,10.1-10,10.1h-84c-5.5,0-10-4.5-10-10.1L-0.2,61.1 L-0.2,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    className: "st1",
    d: "M103.8,61.1h-104l0,0V9.8c0-5.5,4.5-10.1,10-10.1h84c5.5,0,10,4.5,10,10.1V61.1 L103.8,61.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.2,69.9v16.6c0,2.5-0.6,4.4-1.8,5.8c-1.2,1.4-2.9,2.1-5,2.1c-1.2,0-2.3-0.3-3.1-0.8 c-0.9-0.5-1.5-1.1-2.1-1.9l2.7-1.7c0.3,0.3,0.6,0.6,1,0.9s0.9,0.4,1.5,0.4c0.2,0,0.6,0,1-0.1c0.4,0,0.8-0.2,1.2-0.5s0.7-0.8,1-1.4 c0.3-0.6,0.4-1.5,0.4-2.7V69.9H45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.2,73.1v8.8h10.2V85H55.2v8.8H52V69.9h15.8v3.1H55.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.2,69.9v16.6c0,2.5-0.6,4.4-1.8,5.8c-1.2,1.4-2.9,2.1-5,2.1c-1.2,0-2.3-0.3-3.1-0.8 c-0.9-0.5-1.5-1.1-2.1-1.9l2.7-1.7c0.3,0.3,0.6,0.6,1,0.9s0.9,0.4,1.5,0.4c0.2,0,0.6,0,1-0.1c0.4,0,0.8-0.2,1.2-0.5s0.7-0.8,1-1.4 c0.3-0.6,0.4-1.5,0.4-2.7V69.9H45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.2,73.1v8.8h10.2V85H55.2v8.8H52V69.9h15.8v3.1H55.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M72.5,12.9c-0.3,0.6-0.9,1-1.3,1.5c-4.5,4.6-9.9,8-15.5,11.1c-0.8,0.4-1.7,0.4-2,1.5c-2.2,6.6-4.7,13-7.5,19.3 c-1.6,3.6-3.3,7.1-6.3,9.8c-1.3,1.2-1.6,1.2-2-0.8c-0.7-3.5-0.5-7-0.1-10.6C38,41.6,38,38.3,38,35c0-1.1-0.3-1.3-1.4-0.9 c-4.2,1.6-7.9,4.1-11.4,6.8c-4,3-7.9,6.3-11.8,9.5c-4.2,3.4-8.3,7-12.2,10.6c-0.2,0.2-0.5,0.5-0.8,0.7c-0.2,0.2-0.4,0.4-0.6,0.5 V32.4c0.5-0.1,1-0.2,1.5-0.2c6.1-1,12.2-2.2,18.2-3.9c3.9-1.1,7.7-2.2,11.2-4.2c1.4-0.8,1.4-1.2,0-2.2c-4.4-3.4-9-6.7-13.4-10.1 c-1.3-1.1-2.7-2.2-3.7-3.6c0.9-0.8,2-1,3.1-1.3c1.9-0.4,4.9-0.2,6.7,0.2c2.4,0.6,4.9,0.9,7.2,1.8c4.7,1.7,9.4,3.3,14.2,4.7 c2.1,0.6,4.1,1.4,6.5,0.5c3.7-1.4,7.6-2.4,11.5-3.3c2.6-0.6,5.2-1.3,8-0.9C72.6,10,73.4,11.3,72.5,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.9,33.2c0,0-17.9,8.6-20.1,23.7h13.6C69.4,57,64.7,47.3,75.9,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,26.4c0,0-16.3,17-11.8,30.6h24.4C99.3,57,88,57,86.7,26.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJetforce);
export default __webpack_public_path__ + "static/media/Logo-Jetforce.fa27f8b463f5476679f3f4909ff6a7d6.svg";
export { ForwardRef as ReactComponent };